import { render } from "./FormListTable.vue?vue&type=template&id=5cd4160b&scoped=true"
import script from "./FormListTable.vue?vue&type=script&lang=js"
export * from "./FormListTable.vue?vue&type=script&lang=js"

import "./FormListTable.vue?vue&type=style&index=0&id=5cd4160b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd4160b"]])

export default __exports__